export default "__VITE_ASSET__BaVWuk_6__"